import madeStore from "components/jiffy/vue-product-details-print/store/store";
import { MODES } from "components/jiffy/vue-product-details-print/misc/constants";
import { track, startMixpanelRecording } from "common/utils/mixpanel/tracker";
import { track as rudderstackTrack } from "common/utils/rudderstack/tracker";
import { upsertQueryParam } from "common/utils/browser";
import "./pdp-experience-switcher-v2.scss";

const ACTIVE_CLASS_NAME = "pdp-experience-switcher-v2__trigger--active";
const HIDDEN_ELEMENTS_BY_MODE = {
  blanks: {
    hide() {
      madeStore.commit("app/setMode", MODES.BLANKS);
      madeStore.dispatch("checkout/resetPayload");
    },
    show() {
      madeStore.commit("app/setMode", MODES.MADE);
    }
  },
  made: {
    list: [
      ".js-benefits-carousel",
      ".product-details-info-right__bulk_buyers_button",
      ".product-details__bulk_buyers_button",
      "#product-details__section"
    ],
    hide() {
      document.querySelectorAll(this.list.join(",")).forEach($element => {
        $element.classList.add("hidden");
      });
    },
    show() {
      document.querySelectorAll(this.list.join(",")).forEach($element => {
        $element.classList.remove("hidden");
      });
    }
  }
};

const TRACKING_EVENTS = {
  MAIN_TOGGLE: "made_pdp_main_toggle_clicked"
};

const TOGGLE_OPTIONS = {
  BLANKS: {
    mode: "blanks",
    label: "Blanks Only"
  },
  CUSTOM: {
    mode: "made",
    label: "Custom Shirts"
  }
};

const $getSwitcher = () => document.querySelector(".js-pdp-experience-switcher");
const $getSwitcherActions = () => document.querySelectorAll(".js-pdp-experience-switcher-action");

const toggleSwitchersMode = mode => {
  [...$getSwitcherActions()].forEach(switcher => {
    const isSelected = switcher.dataset.mode === mode;
    if (isSelected) {
      switcher.classList.add(ACTIVE_CLASS_NAME);
    } else {
      switcher.classList.remove(ACTIVE_CLASS_NAME);
    }
  });

  Object.keys(HIDDEN_ELEMENTS_BY_MODE).forEach(key => {
    const isHidden = key === mode;
    if (isHidden) {
      HIDDEN_ELEMENTS_BY_MODE[key].hide();
    } else {
      HIDDEN_ELEMENTS_BY_MODE[key].show();
    }
  });

  upsertQueryParam("made", mode === "made" ? "true" : undefined, {
    redirect: false,
    replace: true
  });

  if (mode === "made") {
    startMixpanelRecording(MODES.MADE_SESSION_RECORD_PERCENT);
  }
};

const handleClick = () => {
  // mixpanel tracking data
  const clicksCount = {};

  [...$getSwitcherActions()].forEach($action => {
    $action.addEventListener("click", event => {
      const { mode } = event.target.dataset;
      madeStore.dispatch("app/setMode", mode);

      // mixpanel tracking
      const option =
        mode === TOGGLE_OPTIONS.BLANKS.mode
          ? TOGGLE_OPTIONS.BLANKS.label
          : TOGGLE_OPTIONS.CUSTOM.label;
      clicksCount[option] = (clicksCount[option] || 0) + 1;
      const payload = {
        option,
        number_of_clicks: clicksCount
      };

      try {
        trackEvent(payload, mode);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Failed to track main toggle click:", error);
      }
    });
  });
};

const trackEvent = (payload, mode) => {
  track(TRACKING_EVENTS.MAIN_TOGGLE, payload);
  rudderstackTrack("CTA Clicked", {
    is_app: Boolean(window.MOBILE_APP),
    location: window.location.href,
    platform: window.MOBILE_APP_PLATFORM || "web",
    text: mode,
    type: "button",
    url: window.location.href,
    ...payload
  });
};

const init = () => {
  const $switcher = $getSwitcher();
  if (!$switcher) return;

  // set initial state
  const initialMode = $switcher.dataset?.mode || madeStore?.getters?.["app/mode"] || "blanks";
  madeStore.dispatch("app/setMode", initialMode);

  // change on click
  handleClick();

  // subscribe to store changes
  madeStore.watch(state => state.app.mode, toggleSwitchersMode, { immediate: true });
};

export default init;
